module.exports = __webpack_public_path__ + "static/media/villa-azul-1.f8537587.png";